import { useCallback, useRef } from 'react';

// Returns a stable version of the given function.
// The value (function reference) returned on the first call would always be the same,
// but the called function would always be the latest version passed as the argument.
// In a sense, it's a version of useCallback, which allows to not care about the dependencies.
export function useStableFunc<T extends (...args: any[]) => any>(func: T): T {
	const ref = useRef<T>();
	ref.current = func;
	const stableFunc = useCallback((...args: any) => ref.current?.(...args), []);
	return stableFunc as unknown as T;
}
